import React from 'react';
import ProskinsLogo from '../ui/ProskinsLogo';
import './AuthLayout.css';

const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <div className="auth-layout">
      {/* Left Side - Golf Image */}
      <div className="auth-layout-left">
        <div className="auth-golf-image">
          <div className="auth-golf-overlay">
            <div className="auth-golf-content">
              <h2 className="auth-golf-title">Welcome to PROSKINS</h2>
              <p className="auth-golf-subtitle">
                The ultimate golf betting experience where every swing counts
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - Form */}
      <div className="auth-layout-right">
        <div className="auth-form-container">
          <div className="auth-form-header">
            <ProskinsLogo size="default" showTagline={true} linkTo="/" />
            <h1 className="auth-form-title">{title}</h1>
            {subtitle && <p className="auth-form-subtitle">{subtitle}</p>}
          </div>
          
          <div className="auth-form-content">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
